import { render, staticRenderFns } from "./EmployeeChangeEmailDialog.vue?vue&type=template&id=af213c22&"
import script from "./EmployeeChangeEmailDialog.vue?vue&type=script&lang=ts&"
export * from "./EmployeeChangeEmailDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VContent})
